export function shouldSkipSharingLinksQuery(search = window.location.search) {
    const share = new URLSearchParams(search).get("share")
    return !!share && share !== "clear"
}
